import React from "react";

/**
 * Feature Highlight Card - for showcasing new features in documentation
 */
const FeatureHighlight = ({
  icon = "✨",
  title,
  description,
  features = [],
  badge = null,
  darkMode = false,
}) => {
  const theme = darkMode
    ? {
        cardBg: "#1e293b",
        border: "#334155",
        text: "#e2e8f0",
        textSecondary: "#94a3b8",
        badgeBg: "#3b82f6",
        badgeText: "#ffffff",
        featureBg: "#0f172a",
      }
    : {
        cardBg: "#ffffff",
        border: "#e2e8f0",
        text: "#1e293b",
        textSecondary: "#64748b",
        badgeBg: "#3b82f6",
        badgeText: "#ffffff",
        featureBg: "#f8fafc",
      };

  return (
    <div
      className="feature-highlight"
      style={{
        backgroundColor: theme.cardBg,
        border: `2px solid ${theme.border}`,
        borderRadius: "16px",
        padding: "24px",
        marginBottom: "24px",
        boxShadow: darkMode
          ? "0 4px 20px rgba(0, 0, 0, 0.3)"
          : "0 4px 20px rgba(0, 0, 0, 0.08)",
        minWidth: 0,
        width: "100%",
        wordWrap: "break-word",
        overflowWrap: "break-word",
      }}
    >
      {/* Header with Badge */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ fontSize: "2rem" }}>{icon}</span>
          <h3
            style={{
              margin: 0,
              fontSize: "1.5rem",
              fontWeight: "700",
              color: theme.text,
            }}
          >
            {title}
          </h3>
        </div>
        {badge && (
          <span
            style={{
              backgroundColor: theme.badgeBg,
              color: theme.badgeText,
              padding: "4px 12px",
              borderRadius: "12px",
              fontSize: "0.75rem",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {badge}
          </span>
        )}
      </div>

      {/* Description */}
      {description && (
        <p
          style={{
            color: theme.textSecondary,
            fontSize: "1rem",
            lineHeight: "1.6",
            marginBottom: "20px",
          }}
        >
          {description}
        </p>
      )}

      {/* Features List */}
      {features.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {features.map((feature, index) => (
            <div
              key={index}
              style={{
                backgroundColor: theme.featureBg,
                padding: "12px 16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <span
                style={{
                  fontSize: "1.2rem",
                  minWidth: "24px",
                  textAlign: "center",
                }}
              >
                {feature.icon || "✓"}
              </span>
              <div style={{ flex: 1 }}>
                {feature.title && (
                  <div
                    style={{
                      fontWeight: "600",
                      color: theme.text,
                      marginBottom: "4px",
                    }}
                  >
                    {feature.title}
                  </div>
                )}
                <div
                  style={{
                    color: theme.textSecondary,
                    fontSize: "0.9rem",
                    lineHeight: "1.4",
                  }}
                >
                  {feature.description || feature}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeatureHighlight;
